import apiClient2 from "@/shared/api/apiClient2";

export async function getStatuses() {
  try {
    const { data } = await apiClient2.get("/template-action-rules/statuses");
    return { success: true, payload: data };
  } catch (e) {
    return { success: false, error: e };
  }
}

export async function listRules(formTemplateUuid) {
  try {
    const { data } = await apiClient2.get("/template-action-rules/", {
      params: { form_template_uuid: formTemplateUuid },
    });
    return { success: true, payload: data };
  } catch (e) {
    return { success: false, error: e };
  }
}

export function pickArray(payload) {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.items)) return payload.items;
  if (Array.isArray(payload.payload)) return payload.payload;
  if (Array.isArray(payload.payload?.items)) return payload.payload.items;
  if (Array.isArray(payload.payload?.payload)) return payload.payload.payload;
  return [];
}

export async function getGraph(formTemplateUuid) {
  const [statusesRes, rulesRes] = await Promise.all([
    getStatuses(),
    listRules(formTemplateUuid),
  ]);
  if (!statusesRes.success && !rulesRes.success) {
    return { success: false, error: statusesRes.error || rulesRes.error };
  }
  const allStatuses = pickArray(statusesRes.payload);
  const rules = pickArray(rulesRes.payload);
  return {
    success: true,
    payload: {
      statuses: allStatuses,
      allStatuses,
      rules,
    },
  };
}

export async function createRule(payload) {
  try {
    const { data } = await apiClient2.post("/template-action-rules/", payload);
    return { success: true, payload: data };
  } catch (e) {
    return { success: false, error: e };
  }
}

export async function updateRule(ruleUuid, payload) {
  try {
    const { data } = await apiClient2.put(
      `/template-action-rules/${ruleUuid}`,
      payload
    );
    return { success: true, payload: data };
  } catch (e) {
    return { success: false, error: e };
  }
}

export async function deleteRule(ruleUuid) {
  try {
    const { data } = await apiClient2.delete(
      `/template-action-rules/${ruleUuid}`
    );
    return { success: true, payload: data };
  } catch (e) {
    return { success: false, error: e };
  }
}

export async function seedDefaultRules({
  formTemplateUuid,
  overwrite = false,
}) {
  try {
    const { data } = await apiClient2.post(
      "/template-action-rules/seed-defaults",
      {
        form_template_uuid: formTemplateUuid,
        overwrite,
      }
    );
    return { success: true, payload: data };
  } catch (e) {
    return { success: false, error: e };
  }
}
